<!-- ------------------------------------------------------------ -->
<!-- The content below is only a placeholder and can be replaced. -->
<!-- ------------------------------------------------------------ -->

<ng-container *ngIf="!refreshError">
  <router-outlet
    *ngIf="
      isSoftCustomer ||
      webviewTokenFallback ||
      (securityService.onSessionInitialized$ | async) === undefined
    "
  ></router-outlet>
</ng-container>

<ng-container *ngIf="refreshError">
  <app-ag-error
    [noCancelButton]="true"
    [errorTitle]="'errors.500.title' | translate"
    [errorDescription]="'errors.500.description' | translate"
    [buttonText]="'general.out' | translate"
    (buttonClick)="(true)"
  ></app-ag-error>
</ng-container>
